<template>
  <div class="heart" :style="getStyle" :class="{'heart--jitter': float}">
    <div class="heart__inner" :class="getRotatorClass" :size="`${size}px`"></div>
  </div>
</template>

<script>
export default {
  name: 'Heart',

  props: [
    'endLeft',
    'endTop',
    'size',
    'startLeft',
    'startTop'
  ],

  data () {
    return {
      float: false
    }
  },

  computed: {
    getStyle () {
      const startPos = `left: ${this.startLeft}%; top: ${this.startTop}%;`
      return this.float ? `${startPos}; width: ${this.size}px; height: ${this.size}px; transform: translate(${this.endTop}%, ${this.endLeft}%); opacity: 0;` : startPos
    },

    getRotatorClass () {
      const index = Math.floor(Math.random() * 2) + 1
      return `heart__inner--${index}`
    }
  },

  mounted () {
    setTimeout(() => {
      this.float = true
    }, 0)
  }
}
</script>

<style lang="scss" scoped>
.heart {
  left: 0;
  opacity: .75;
  pointer-events: none;
  position: absolute;
  top: 0;
  transition: transform 2s ease-in, opacity 2s ease-in;
}

.heart__inner {
  background: url(/static/img/p_heart.svg) no-repeat;
  background-size: 120px 105px;
  height: 120px;
  width: 120px;
}

.heart__inner--1 {
  animation: rotator-1 2s ease-in;
}

.heart__inner--2 {
  animation: rotator-2 2s ease-in;
  background: url(/static/img/p_heart.svg) no-repeat;
  background-size: 56px 49px;
}

.heart--jitter {
  animation: jitter 2s ease-in;
}

@keyframes jitter {
  0% {
    margin-left: 0%;
  }

  25% {
    margin-left: 1%;
  }

  50% {
    margin-left: -2%;
  }

  75% {
    margin-left: 2%;
  }

  100% {
    margin-left: -7%;
  }
}

@keyframes rotator-1 {
  0% {
    transform: rotate(-1deg);
  }

  25% {
    transform: rotate(2deg);
  }

  50% {
    transform: rotate(-3deg);
  }

  75% {
    transform: rotate(4deg);
  }

  100% {
    transform: rotate(-5deg);
  }
}

@keyframes rotator-2 {
  0% {
    transform: rotate(1deg);
  }

  15% {
    transform: rotate(-2deg);
  }

  35% {
    transform: rotate(3deg);
  }

  65% {
    transform: rotate(-4deg);
  }

  90% {
    transform: rotate(5deg);
  }

  100% {
    transform: rotate(6deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Heart.vue